import { render, staticRenderFns } from "./StatisticCardVerticalComments.vue?vue&type=template&id=7ac1d4db&"
import script from "./StatisticCardVerticalComments.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports